import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { lazy, Suspense } from 'react';
import { PreloadCriticalAssets } from "@/components/PreloadCriticalAssets";
import { PerformanceOptimizer } from "@/components/PerformanceOptimizer";
import Index from "./pages/Index";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load non-critical pages
const Blog = lazy(() => import("./pages/Blog"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Contact = lazy(() => import("./pages/Contact"));
const BookNow = lazy(() => import("./pages/BookNow"));
const PrePurchaseInspection = lazy(() => import("./pages/PrePurchaseInspection"));
const CarServicing = lazy(() => import("./pages/CarServicing"));
const Diagnostics = lazy(() => import("./pages/Diagnostics"));
const MobileRepairs = lazy(() => import("./pages/MobileRepairs"));
const NotFound = lazy(() => import("./pages/NotFound"));
const GetQuote = lazy(() => import("./pages/GetQuote"));
const ServiceAreas = lazy(() => import("./pages/ServiceAreas"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <PerformanceOptimizer />
        <PreloadCriticalAssets />
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<Suspense fallback={<div />}><AboutUs /></Suspense>} />
          <Route path="/blog" element={<Suspense fallback={<div />}><Blog /></Suspense>} />
          <Route path="/blog/:slug" element={<Suspense fallback={<div />}><Blog /></Suspense>} />
          <Route path="/contact" element={<Suspense fallback={<div />}><Contact /></Suspense>} />
          <Route path="/book-now" element={<Suspense fallback={<div />}><BookNow /></Suspense>} />
          <Route path="/services/pre-purchase-inspection" element={<Suspense fallback={<div />}><PrePurchaseInspection /></Suspense>} />
          <Route path="/services/car-servicing" element={<Suspense fallback={<div />}><CarServicing /></Suspense>} />
          <Route path="/services/diagnostics" element={<Suspense fallback={<div />}><Diagnostics /></Suspense>} />
          <Route path="/services/mobile-repairs" element={<Suspense fallback={<div />}><MobileRepairs /></Suspense>} />
          <Route path="/get-quote" element={<Suspense fallback={<div />}><GetQuote /></Suspense>} />
          <Route path="/service-areas" element={<Suspense fallback={<div />}><ServiceAreas /></Suspense>} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<Suspense fallback={<div />}><NotFound /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  </HelmetProvider>
);

export default App;